import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Toolbar, useTheme, useMediaQuery } from '@mui/material';
import Navbar from '../components/common/Navbar';
import Sidebar, { DRAWER_WIDTH, COLLAPSED_DRAWER_WIDTH } from '../components/common/Sidebar';
import { useAuth } from '../context/AuthContext';

const BusinessLayout = () => {
  const { user } = useAuth();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  // Desktop: sidebar starts fully expanded; toggling collapses it to an icon rail.
  // Mobile: sidebar starts hidden; toggling shows/hides the overlay.
  const [desktopOpen, setDesktopOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    if (isDesktop) {
      setDesktopOpen((prev) => !prev);
    } else {
      setMobileOpen((prev) => !prev);
    }
  };

  // Only render if user is business user
  if (!user || user.role !== 'business') {
    return <h1>Access defined</h1>;
  }

  const currentDrawerWidth = isDesktop ? (desktopOpen ? DRAWER_WIDTH : COLLAPSED_DRAWER_WIDTH) : 0;

  return (
    <Box sx={{ display: 'flex' }}>
      <Navbar onMenuClick={handleDrawerToggle} />

      <Sidebar
        desktopOpen={desktopOpen}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          width: { xs: '100%', md: `calc(100% - ${currentDrawerWidth}px)` },
          minHeight: '100vh',
          backgroundColor: 'background.default',
          p: { xs: 2, sm: 3 },
          transition: (t) => t.transitions.create('width', {
            easing: t.transitions.easing.sharp,
            duration: t.transitions.duration.enteringScreen,
          }),
        }}
      >
        <Toolbar sx={{ minHeight: { xs: 64, sm: 72 } }} />
        <Outlet />
      </Box>
    </Box>
  );
};

export default BusinessLayout;
